<script setup lang="ts">
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import UserArea from "@/components/ui/UserArea.vue";
import { ref } from "vue";
import { gql } from "@apollo/client/core";
import { useMutation, useQuery, useResult } from "@vue/apollo-composable";
import { useAuthStore } from "@/stores/auth";
import { getMessageFromError } from "@/libs/errors";
import { useRouter } from "vue-router";

const router = useRouter();
const authStore = useAuthStore();
const displayModeMobile = ref(false);
const name = ref();
const email = ref();
const phone = ref();
const state = ref();
const errorMessage = ref("");
const loading = ref(false);
const loadingUser = ref(true);

const {
  loading: userLoading,
  error,
  result,
  refetch,
  onResult,
} = useQuery(gql`
  query Me {
    me {
      id
      name
      email
      phone
      state
    }
  }
`);

const user = useResult(result, null, (data) => data.me);

const setRefs = () => {
  if (!user.value) {
    return;
  }
  name.value = user.value.name;
  state.value = user.value.state;
  email.value = user.value.email;
  phone.value = user.value.phone;
  loadingUser.value = false;
};
setRefs();
onResult(setRefs);

const { mutate: updateUserProfile } = useMutation(gql`
  mutation UpdateMyUser($input: UpdateUserInput!) {
    updateMyUser(input: $input) {
      id
      name
      phone
      state
    }
  }
`);

const updateUser = async () => {
  if (loading.value) {
    return;
  }
  loading.value = true;
  try {
    await updateUserProfile({
      input: {
        name: name.value,
        phone: phone.value,
        state: state.value,
      },
    });
    authStore.setName(name.value);
    authStore.setState(state.value);
    router.push("/user/my-personal-data");
    alert("Dados atualizados com sucesso.");
  } catch (err) {
    errorMessage.value = getMessageFromError(err);
  }
  loading.value = false;
};
</script>

<template>
  <DefaultLayout>
    <article class="container framework-slot">
      <UserArea title="Dados Pessoais">
        <form @submit.prevent="updateUser">
          <div v-if="loadingUser" class="row">
            <div class="col-md-12 mb-3">CARREGANDO DADOS...</div>
          </div>
          <div v-else class="row">
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label for="name" class="form-label">Nome</label>
                <div class="input-group">
                  <input
                    id="name"
                    type="text"
                    class="form-control"
                    v-model="name"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label for="state" class="form-label">Localização</label>
                <div class="input-group">
                  <select id="state" class="form-select" v-model="state">
                    <option value="AC">Acre</option>
                    <option value="AL">Alagoas</option>
                    <option value="AP">Amapá</option>
                    <option value="AM">Amazonas</option>
                    <option value="BA">Bahia</option>
                    <option value="CE">Ceará</option>
                    <option value="DF">Distrito Federal</option>
                    <option value="ES">Espírito Santo</option>
                    <option value="GO">Goiás</option>
                    <option value="MA">Maranhão</option>
                    <option value="MT">Mato Grosso</option>
                    <option value="MS">Mato Grosso do Sul</option>
                    <option value="MG">Minas Gerais</option>
                    <option value="PA">Pará</option>
                    <option value="PB">Paraíba</option>
                    <option value="PR">Paraná</option>
                    <option value="PE">Pernambuco</option>
                    <option value="PI">Piauí</option>
                    <option value="RJ">Rio de Janeiro</option>
                    <option value="RN">Rio Grande do Norte</option>
                    <option value="RS">Rio Grande do Sul</option>
                    <option value="RO">Rondônia</option>
                    <option value="RR">Roraima</option>
                    <option value="SC">Santa Catarina</option>
                    <option value="SP">São Paulo</option>
                    <option value="SE">Sergipe</option>
                    <option value="TO">Tocantins</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label for="email" class="form-label">E-mail</label>
                <div class="input-group">
                  <input
                    id="email"
                    type="email"
                    class="form-control"
                    v-model="email"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label for="phone" class="form-label">Celular</label>
                <div class="input-group">
                  <input
                    v-maska="['(##) ####-####', '(##) #####-####']"
                    id="phone"
                    type="tel"
                    class="form-control"
                    v-model="phone"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <button
                v-if="loading"
                class="btn btn-primary mb-3 width-200px"
                type="submit"
                disabled
              >
                Salvando...
              </button>
              <button
                v-else-if="loadingUser"
                class="btn btn-primary mb-3 width-200px"
                type="submit"
                disabled
              >
                Carregando...
              </button>
              <button
                v-else
                class="btn btn-primary mb-3 width-200px"
                type="submit"
              >
                Salvar Alterações
              </button>
            </div>
          </div>
        </form>
      </UserArea>
    </article>
  </DefaultLayout>
</template>

<style scoped></style>
